@for (item of rawsInfo; track item; let i = $index) {
  <div
    class="sb-row"
    [class.sb-row_info]="i !== 0"
    >
    <div class="sb-row__info-label">{{ item.title }}</div>
    <div class="sb-row__info">{{ item.value }}</div>
  </div>
}
